import React = require("react");
import {RestDataLoader} from "../dashboard/widgets/unilever/RestDataLoader";
import "./AccountRecoveryPage.scss";
import {Button, icons} from "@vebox/etui-core";
import {VeBoxLoginCard} from "../components/card/VeBoxLoginCard";
import {VeboxLoginInput} from "../components/card/VeboxLoginInput/VeboxLoginInput";
import {Display} from "../components/Display";
import {RecoveryTexts} from "./AccountRecoveryPage";

interface PasswordResetPageProps {
    onBackClick: () => void;
    email: string;
    texts: RecoveryTexts;
}

interface PasswordResetPageState {
    code: string;
    username: string;
    password: string;
    confirmedPassword: string;
    passwordChanged: boolean;
    error: string;
}

interface FormValidation {
    isValid: boolean;
    error: string;
}

export class PasswordResetPage extends React.Component<PasswordResetPageProps, PasswordResetPageState> {

    public static goToLoginPage() {
        window.location.replace("./login");
    }

    constructor(props) {
        super(props);
        this.state = {
            code: "",
            username: "",
            password: "",
            confirmedPassword: "",
            passwordChanged: false,
            error: null,
        };
        this.resetPassword = this.resetPassword.bind(this);
        this.updateCode = this.updateCode.bind(this);
        this.updateUsername = this.updateUsername.bind(this);
        this.updatePassword = this.updatePassword.bind(this);
        this.updateConfirmedPassword = this.updateConfirmedPassword.bind(this);
        PasswordResetPage.goToLoginPage = PasswordResetPage.goToLoginPage.bind(this);
    }

    public render() {
        let content = null;
        const texts = this.props.texts;
        if (!this.state.passwordChanged) {
            content = (
                <VeBoxLoginCard className={"loginCard"}>
                    <VeBoxLoginCard.Header
                        className={"login-card-header"}
                    >
                        <div style={{display: "flex"}}>
                            <Button
                                className={"back-button"}
                                variant={"tertiary"}
                                shape={"circle"}
                                onClick={this.props.onBackClick}
                                styles={{root: {height: 30, width: 30}}}
                                iconProps={{glyph: icons.ARROW_DOWN}}
                            />
                            <VeBoxLoginCard.Title text={texts.changeCredentials} style={{padding: "5px 0"}}/>
                        </div>
                    </VeBoxLoginCard.Header>
                    <VeBoxLoginCard.Body className={"mainContentDiv"}>
                            <span className={"intro-text"}>
                                {this.replaceEmail(texts.enterOtpAndNewCredentials)}
                            </span>
                        <Display isVisible={this.state.error !== null}>
                                <span className={"error-text"}>
                                        {this.state.error}
                                    </span>
                        </Display>
                        <div className={"formDiv"}>
                            <VeboxLoginInput
                                type={"text"}
                                className={"loginInputField"}
                                onChange={this.updateCode}
                                value={this.state.code}
                                placeholder={texts.insertOtp}
                            />
                            <VeboxLoginInput
                                type={"text"}
                                className={"loginInputField"}
                                onChange={this.updateUsername}
                                value={this.state.username}
                                placeholder={texts.insertUsername}
                            />
                            <VeboxLoginInput
                                type={"text"}
                                className={"loginInputField"}
                                onChange={this.updatePassword}
                                value={this.state.password}
                                placeholder={texts.insertNewPassword}
                            />
                            <VeboxLoginInput
                                type={"text"}
                                className={"loginInputField"}
                                onChange={this.updateConfirmedPassword}
                                value={this.state.confirmedPassword}
                                placeholder={texts.confirmNewPassword}
                            />
                        </div>
                    </VeBoxLoginCard.Body>
                    <VeBoxLoginCard.Footer style={{textAlign: "end"}}>
                        <Button
                            variant={"strong"} onClick={this.resetPassword}
                        >
                            {texts.continueText}
                        </Button>
                    </VeBoxLoginCard.Footer>
                </VeBoxLoginCard>
            );
        } else {
            content = (
                <React.Fragment>
                    <VeBoxLoginCard className={"loginCard"}>
                        <VeBoxLoginCard.Header
                            className={"login-card-header"}
                        >
                            <VeBoxLoginCard.Title text={texts.passwordChanged}/>
                        </VeBoxLoginCard.Header>
                        <VeBoxLoginCard.Body className={"mainContentDiv"}>
                            <Button
                                variant={"strong"} onClick={PasswordResetPage.goToLoginPage}
                            >
                                {texts.login}
                            </Button>
                        </VeBoxLoginCard.Body>
                    </VeBoxLoginCard>
                </React.Fragment>
            );
            setTimeout(() => {
                PasswordResetPage.goToLoginPage();
            }, 4000);
        }
        return (
            <div>
                {content}
            </div>
        );
    }

    private replaceEmail(text) {
        return text.replace("%s", this.props.email);
    }

    private resetPassword() {
        const texts = this.props.texts
        const validation = this.validateForm();
        if (!validation.isValid) {
            this.setState({error: validation.error});
            return;
        }

        RestDataLoader.putJSON(
            "support/recovery/password",
            {
                otp: this.state.code,
                username: this.state.username,
                password: this.state.password,
            },
            () => {
                this.setState({passwordChanged: true});
            },
            (error) => {
                switch (error.errorType) {
                    case "INVALID_PASSWORD":
                        this.setState({error: texts.wrongOtpCode});
                        return;
                    case "HTTP_BAD_REQUEST":
                        this.setState({error: texts.passwordNotSecure});
                        return;
                    case "INVALID_USERNAME":
                        this.setState({error: texts.invalidUsername});
                        return;
                }
                return;
            },
        );
    }

    private validateForm(): FormValidation {
        const texts = this.props.texts
        if (this.state.code.trim() === ""
            || this.state.username.trim() === ""
            || this.state.password.trim() === ""
            || this.state.confirmedPassword.trim() === "") {
            return {
                isValid: false,
                error: texts.allFieldsMandatory,
            };
        }
        if (this.state.password !== this.state.confirmedPassword) {
            return {
                isValid: false,
                error: texts.passwordsAreDifferent,
            };
        }
        return {
            isValid: true,
            error: null,
        };
    }

    private updateCode(evt) {
        this.setState({code: evt.target.value, error: null});
    }

    private updateUsername(evt) {
        this.setState({username: evt.target.value, error: null});
    }

    private updatePassword(evt) {
        this.setState({password: evt.target.value, error: null});
    }

    private updateConfirmedPassword(evt) {
        this.setState({confirmedPassword: evt.target.value, error: null});
    }
}
